var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"hamburger relative inline-block align-middle z-20",class:{ active: _vm.isActive },on:{"click":function($event){return _vm.toggleMenu()}}},[_c('span',{staticClass:"block relative w-full h-1 bg-primary rounded"})])}
var staticRenderFns = []

export { render, staticRenderFns }